import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import { Link } from 'react-router-dom';
import AppNotification from 'Components/AppNotification/AppNotification.jsx';
// import { NavLink } from 'react-router-dom';
import './QueuesDropdown.scss';
import { VITE_AVAILABLE_QUEUES } from 'Constants/appEnvConstants';
 
class QueuesDropdown extends Component {
  constructor(props) {
    super(props);

    this.toggleQueueList = this.toggleQueueList.bind(this);
    this.selectQueue = this.selectQueue.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    // this.filterQueueList = this.filterQueueList.bind(this);

    this.state = {
      queueListVisible: false,
      filteredQueueList: [],
      acquirerCode:JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode
    };
  }

  componentDidMount() {
    // this.filterQueueList(this.props.queueList);
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleOutsideClick(event) {
    if (this.queueList && !this.queueList.contains(event.target) && this.state.queueLPistVisible) {
      this.toggleQueueList();
    }
  }

  filterQueueList(queueList) {
    let filteredQueueList;
    queueList.map((queue) => {
      if (VITE_AVAILABLE_QUEUES.indexOf(queue.queueId) !== -1) {
        filteredQueueList.push(queue);
      }
    });
    this.setState({
      filteredQueueList,
    });
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      selectedRole: newProps.currentQueue,
    });
  }

  toggleQueueList(event) {
    this.setState({
      queueListVisible: !this.state.queueListVisible,
    });
  }

  selectQueue(queueId, regionCode, queueName, acquirerAccessCode){
    this.props.selectQueue(queueId, regionCode, queueName, acquirerAccessCode);
    this.toggleQueueList();
  }


  render() {
    const acquirerCode = this.state.acquirerCode;
    return (
      <div className="queueList-wrapper" ref={(ref) => { this.queueList = ref; }}>
        <div
          role="button"
          tabIndex={0}
          className={'queue-dropdown-trigger _profile'+acquirerCode}
          onClick={this.toggleQueueList}
          aria-expanded={this.state.queueListVisible}
        >
          <span className={'gd-report-runner__filter-toggle _profile'+acquirerCode}>{this.state.selectedRole}</span>
        </div>

        {this.state.queueListVisible ? (<div>
          <ul className="queues-dropdown">
            {this.props.queueList && this.props.queueList.map((item) => {
              return (
                <li className="vertical-nav-item" key={item.queueName}>
                  <div
                    className={'vertical-nav-action _profile'+acquirerCode}
                    role="button"
                    onClick={() => this.selectQueue(item.queueId, item.regionCode, item.queueName, item.acquirerAccessCode)}
                    key={item.queueName}
                  >
                    <span id="label" className="vertical-nav-label">
                      {item.queueName} &nbsp;
                     {this.props.isMerchantPortal != undefined && this.props.isMerchantPortal ? '':
                     ( <AppNotification
                        className="app-notification-badge"
                        info
                      >
                        {item.count}
                      </AppNotification> )}
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>) : (null)}

      </div>

    );
  }
}
QueuesDropdown.propTypes = {
  extraClass: PropTypes.string,
  queuesList: PropTypes.array.isRequired,
};

QueuesDropdown.defaultProps = {
  extraClass: '',
  queuesList: [],
};

export function findItem(list, selectedValue) {
  return list.find((item) => item.text === selectedValue);
}

export default QueuesDropdown;
